var $ = require('../modules/jquery');
var _throttle = require('lodash/throttle');
var enquire = require('../modules/enquire');
var objectFitImages = require('object-fit-images');

var shouldResizeDropdowns = true;
var navbarOffset = 115;
var maxDropdownHeight = $(window).height() - navbarOffset;

objectFitImages();

// Functions
// ---------------------------------------------------------------------------
function togglePanel() {
  var element = $(this);
  var panel = $('#' + element.attr('aria-controls'));
  var body = $('body');

  // reset scroll position of panel content
  if (!panel.is('.panel--active')) {
    panel.scrollTop(0);
  }

  // toggle active classes
  body.toggleClass('clipped');
  element.toggleClass('toggle--active');
  panel.toggleClass('panel--active');

  // if search, then focus on input
  if (element.is('#toggle--search')) {
    $('#site-search').focus();
  }
}

function resetPanel(element) {
  var panel = $('#' + element.attr('aria-controls'));
  var body = $('body');

  // remove active classes
  element.removeClass('toggle--active');
  panel.removeClass('panel--active');
}

function toggleDropdown(event) {
  var target = event.target;
  var element = $(this);
  var menu = element.closest('.menu');
  var dropdown = element.parent().find('.menu__dropdown');

  // prevent default
  event.preventDefault();

  // check if this item is active
  if (element.parent().is('.menu__item--active')) {

    // hide this item's dropdown
    element.parent().removeClass('menu__item--active');
    dropdown.removeClass('menu__dropdown--active');

  } else {

    // hide any active dropdowns
    menu.find('.menu__item--active').removeClass('menu__item--active');
    menu.find('.menu__dropdown--active').removeClass('menu__dropdown--active');

    // show this item's dropdown
    element.parent().addClass('menu__item--active');
    dropdown.addClass('menu__dropdown--active');

    // set active dropdown's max height if dropdown exceeds window height
    dropdown.css({
      'max-height': '',
      'overflow': ''
    });
    if (shouldResizeDropdowns && (dropdown.outerHeight() > maxDropdownHeight)) {
      dropdown.css({
        'max-height': maxDropdownHeight,
        'overflow': 'scroll'
      });
    }
  }
}


// Header search / menu toggles
// ---------------------------------------------------------------------------
var toggle_menu = $('#toggle--menu');
var toggle_search = $('#toggle--search');

// only applies to mobile
enquire.register('screen and (max-width: 1023px)', {
  match: function () {
    toggle_menu.on('click', togglePanel);
    toggle_search.on('click', togglePanel);
    shouldResizeDropdowns = false;
  },
  unmatch: function () {
    toggle_menu.unbind('click');
    toggle_search.unbind('click');
    resetPanel(toggle_menu);
    resetPanel(toggle_search);
    shouldResizeDropdowns = true;
  }
});


// Header dropdown menus
// ---------------------------------------------------------------------------
var dropdown_parent = $('#menu--primary').find('.menu__item--dropdown > a');

// applies across all devices
dropdown_parent.on('click', toggleDropdown);

// listen for document clicks
$(document).click(function (event) {
  var target = event.target;

  if (!$(target).is('#menu--primary .menu__item--dropdown > a')) {
    var menu = $('#menu--primary');

    // hide any active dropdowns
    menu.find('.menu__item--active').removeClass('menu__item--active');
    menu.find('.menu__dropdown--active').removeClass('menu__dropdown--active');
  }
});

// listen for window resize
var updateOnWindowResize = _throttle(function (e) {
  maxDropdownHeight = $(window).height() - navbarOffset;
}, 100);

$(window).resize(updateOnWindowResize);



//////////////////
// WEBPACK FOOTER
// ./web/themes/contrib/nccourts-theme/assets/src/js/components/header.js
// module id = 29
// module chunks = 4